import React, { useState } from 'react';

const SubmitConfirmModal = ({ show, handleClose, handleConfirm }) => {
    const [sendToMoadian, setSendToMoadian] = useState(false);

    if (!show) return null;

    const onConfirmClick = () => {
        handleConfirm(sendToMoadian);
    };

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">ثبت صورتحساب</h5>
                        <button type="button" className="btn-close" onClick={handleClose}></button>
                    </div>
                    <div className="modal-body">
                        <p className="mb-4 text-dark">
                            برای ثبت و ارسال صورتحساب به صورت مستقیم به سامانه مودیان باید کلید خصوصی و فایل سرتیفیکیت 
                            رو حتما در قسمت شعب ثبت کرده باشید
                        </p>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="sendToMoadianCheck"
                                checked={sendToMoadian}
                                onChange={(e) => setSendToMoadian(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="sendToMoadianCheck">
                                اختصاص شناسه یکتا و ارسال به سامانه مودیان
                            </label>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleClose}>
                            لغو
                        </button>
                        <button type="button" className="btn btn-success" onClick={onConfirmClick}>
                            ثبت
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubmitConfirmModal;
